// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class DownloadLink extends Vue {
  @Prop()
  public href!: string;

  @Prop({ default: "_blank" })
  public target!: string;

  @Prop()
  public text!: string;

  @Prop()
  public statsText!: string;

  @Prop({ default: "default" })
  public theme!: "default" | "secondary";
}
